import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll'
import { MenuIcon, XIcon } from '@heroicons/react/outline';
import ContactModal from './ContactModal';

const Navbar = () => {
    const [nav, setNav] = useState(false)
    const [scrolled, setScrolled] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false)

    const handleClick = () => setNav(!nav)
    const handleClose = () => setNav(false)
    const openModal = () => {
        setIsModalOpen(true)
        setNav(false)
    }
    const closeModal = () => setIsModalOpen(false)

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50)
        }
        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    return (
        <>
            <div className={`w-screen h-[80px] z-50 fixed transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
                }`}>
                <div className='px-4 md:px-8 flex justify-between items-center w-full h-full max-w-[1400px] mx-auto'>
                    <div className='flex items-center'>
                        {/* <h1 className='text-3xl md:text-4xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent cursor-pointer'>YoursTech.</h1> */}
                        <h1 className='text-3xl md:text-4xl font-bold bg-black bg-clip-text text-transparent cursor-pointer'>
                            YoursTech.
                        </h1>
                    </div>

                    <div className='hidden md:flex items-center'>
                        <ul className='flex space-x-8 mr-8'>
                            <li className='text-gray-700 hover:text-indigo-600 transition-colors duration-200 font-medium cursor-pointer'>
                                <Link to="home" smooth={true} duration={500}>Accueil</Link>
                            </li>
                            <li className='text-gray-700 hover:text-indigo-600 transition-colors duration-200 font-medium cursor-pointer'>
                                <Link to="services" smooth={true} offset={-80} duration={500}>Services</Link>
                            </li>
                        </ul>
                        <button
                            onClick={openModal}
                            className='px-6 py-2.5 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 transition-all duration-200 transform hover:scale-105 shadow-md'
                        >
                            Contact
                        </button>
                    </div>

                    <div className='md:hidden' onClick={handleClick}>
                        {!nav ? <MenuIcon className='w-7 text-gray-700 cursor-pointer' /> : <XIcon className='w-7 text-gray-700 cursor-pointer' />}
                    </div>
                </div>

                <div className={`${!nav ? 'hidden' : 'absolute'} bg-white w-full shadow-lg md:hidden`}>
                    <ul className='px-8 py-4'>
                        <li className='border-b-2 border-gray-100 py-4'>
                            <Link onClick={handleClose} to="home" smooth={true} duration={500} className='text-gray-700 hover:text-indigo-600 font-medium cursor-pointer'>
                                Accueil
                            </Link>
                        </li>
                        <li className='border-b-2 border-gray-100 py-4'>
                            <Link onClick={handleClose} to="services" smooth={true} offset={-80} duration={500} className='text-gray-700 hover:text-indigo-600 font-medium cursor-pointer'>
                                Services
                            </Link>
                        </li>
                        <li className='py-4'>
                            <button
                                onClick={openModal}
                                className='w-full py-3 bg-gradient-to-r from-indigo-600 to-purple-600'
                            >
                                Contact
                            </button>
                        </li>
                    </ul>
                </div>
            </div>

            <ContactModal isOpen={isModalOpen} onClose={closeModal} />
        </>
    );
};

export default Navbar;